/* THE TWO REPORT BUTTONS OF THE WHOLE PANEL — EVERY SECTION DRAWS THE VERY SAME PAIR
 * downloading keeps the key of the report being built: "xlsx", "pdf" or null */


/* DOWNLOAD ICON */
const DownloadIcon = ({ size = 14 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3.6v10.8" />
        <path d="M7.6 10.4 12 14.8l4.4-4.4" />
        <path d="M4.4 18.4h15.2" />
    </svg>
)

/* SPINNER ICON — THE REPORT IS BEING BUILT */
const SpinnerIcon = ({ size = 14 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
        <path d="M12 3.4a8.6 8.6 0 1 1-8.6 8.6" />
    </svg>
)


/* Component Report */
const Report = ({ excel, pdf, downloading = null }) => {

    /* Fields */
    const busy = downloading !== null

    /* Draw One Button */
    const button = (key, label, action) => {

        /* Fields */
        const waiting = downloading === key
        const disabled = busy && !waiting

        return (
            <div
                onClick={() => (busy || !action ? null : action())}
                className={`report--button ${key} ${waiting ? "waiting" : ""} ${disabled ? "disabled" : ""}`}
            >
                {waiting ? <SpinnerIcon /> : <DownloadIcon />}
                <span>{label}</span>
            </div>
        )
    }

    return (
        <div className="report--buttons">
            {excel !== undefined && button("xlsx", "XLSX", excel)}
            {pdf !== undefined && button("pdf", "PDF", pdf)}
        </div>
    )
}

export default Report
